import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScripts } from '../../../helpers/Utils';

export function TradingAgencyProfileCustomPage(): React.ReactElement {
  const currentSecurity = useSecurity('Trading', 'AgencyProfile');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScripts([
        'Areas/Trading/Scripts/Resources/en/res.AgencyProfile.en.js',
        'Areas/Trading/Scripts/Resources/en/Types.en.js',
        'Areas/Trading/Scripts/Enums.js',
        'Areas/Trading/Scripts/AgencyProfile/Index.custom.js',
      ]);
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
